import React from "react";

import { Form, Input, Modal, Select, message, Upload, Icon } from "antd";
import { fetchEditShop, fetchAddShop } from "../../../../api/shop";
import { upload_token } from "../../../../utils/token";
const formItemLayout = {
  labelCol: {
    xs: { span: 12 },
    sm: { span: 6 },
  },
  wrapperCol: {
    xs: { span: 36 },
    sm: { span: 18 },
  },
};
function getBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });
}
const { Option } = Select;
class EditShop extends React.Component {
  state = {
    previewVisible: false,
    previewImage: "",
  };
  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(async (err, values) => {
      if (!err) {
        console.log(values);
        if (this.props.shopInfo.id) {
          fetchEditShop({
            ...values,
            id: this.props.shopInfo.id,
            logo:
              this.props.fileList.length >= 1
                ? this.props.fileList[0].response
                  ? this.props.fileList[0].response.key
                  : this.props.fileList[0].url.split("com/")[1]
                : "",
            companyId: this.props.companyId,
          }).then((res) => {
            if (res.success) {
              message.success("操作成功");
              this.props.getList();
              this.props.handleCancel();
            }
          });
        } else {
          fetchAddShop({
            ...values,
            logo:
              this.props.fileList.length >= 1
                ? this.props.fileList[0].response.key
                : "",
            companyId: this.props.companyId,
          }).then((res) => {
            if (res.success) {
              message.success("操作成功");
              this.props.getList();
              this.props.handleCancel();
            }
          });
        }
      }
    });
  };
  handlePreview = async (file) => {
    console.log(file);

    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }

    this.setState({
      previewImage: file.url || file.preview,
      previewVisible: true,
    });
  };
  handlePreviewCancel = () => this.setState({ previewVisible: false });
  render() {
    const { getFieldDecorator } = this.props.form;
    const { previewVisible, previewImage } = this.state;
    const {
      visible,
      handleCancel,
      isadd,
      shopInfo,
      fileList,
      handleChange,
    } = this.props;
    return (
      <React.Fragment>
        {" "}
        <Modal
          destroyOnClose={true}
          title={isadd ? "添加店铺" : "编辑店铺"}
          visible={visible}
          onOk={this.handleOk}
          onCancel={handleCancel}
        >
          <Form onSubmit={this.handleOk} {...formItemLayout}>
            <Form.Item label="店铺名称">
              {getFieldDecorator("name", {
                initialValue: shopInfo.name,
                rules: [{ required: true, message: "请输入店铺名称" }],
              })(<Input placeholder="请输入店铺名称" />)}
            </Form.Item>
            <Form.Item label="店铺编号">
              {getFieldDecorator("shopId", {
                initialValue: shopInfo.shopId,
                rules: [{ required: true, message: "请输入店铺编号" }],
              })(<Input placeholder="请输入店铺编号" />)}
            </Form.Item>
            <Form.Item label="店铺地址">
              {getFieldDecorator("address", {
                initialValue: shopInfo.address,
              })(<Input.TextArea rows={3} placeholder="请输入店铺地址" />)}
            </Form.Item>
            <Form.Item label="店铺logo">
              <Upload
                accept="image/*"
                data={{
                  token: upload_token(),
                  key: new Date().getTime(),
                }}
                action="https://upload.qiniup.com/"
                listType="picture-card"
                fileList={fileList}
                onPreview={this.handlePreview}
                onChange={handleChange}
              >
                {fileList.length >= 1 ? null : (
                  <div>
                    <Icon type="plus" />
                    <div className="ant-upload-text">上传图片</div>
                  </div>
                )}
              </Upload>
              <span style={{ color: "rgba(0,0,0,0.45)", fontSize: 14 }}>
                仅支持png、jpg、jpge格式，尺寸比例建议1:1
              </span>
            </Form.Item>
          </Form>
        </Modal>{" "}
        <Modal
          visible={previewVisible}
          footer={null}
          onCancel={this.handlePreviewCancel}
        >
          <img alt="example" style={{ width: "100%" }} src={previewImage} />
        </Modal>
      </React.Fragment>
    );
  }
}

export default Form.create()(EditShop);
